/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Segment_HelpInputs */

const en_ad_segment_help = /** @type {(inputs: Ad_Segment_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the selected portion of the video is sent to the AI. Use this to skip slate, colour bars, or tail content - the start and end timecodes are inclusive.`)
};

const fr_ad_segment_help = /** @type {(inputs: Ad_Segment_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seule la portion de vidéo sélectionnée est envoyée à l'IA. Utilisez cette fonction pour ignorer les ardoises, les barres de couleur ou le contenu de fin ; les horodatages de début et de fin sont inclus.`)
};

const de_ad_segment_help = /** @type {(inputs: Ad_Segment_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur der ausgewählte Videoausschnitt wird an die KI gesendet. Verwenden Sie diese Funktion, um Einblendungen, Farbbalken oder Abspanninhalte zu überspringen – die Start- und Endzeitcodes sind inklusive.`)
};

const it_ad_segment_help = /** @type {(inputs: Ad_Segment_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo la porzione selezionata del video viene inviata all'IA. Utilizza questa opzione per saltare la schermata iniziale, le barre colore o la parte finale del video: i timecode di inizio e fine sono inclusi.`)
};

const ru_ad_segment_help = /** @type {(inputs: Ad_Segment_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Искусственному интеллекту отправляется только выбранная часть видео. Используйте эту функцию, чтобы пропустить заставку, цветные полосы или финальную часть видео — начальная и конечная временные метки включены.`)
};

const es_ad_segment_help = /** @type {(inputs: Ad_Segment_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo se envía a la IA la parte seleccionada del vídeo. Utilice esta función para omitir la claqueta, las barras de color o el contenido final; los códigos de tiempo de inicio y fin se incluyen.`)
};

const zh_cn2_ad_segment_help = /** @type {(inputs: Ad_Segment_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅将选定的视频部分发送给人工智能。使用此功能可跳过片头、彩条或片尾内容——起始和结束时间码包含在内。`)
};

const ja_ad_segment_help = /** @type {(inputs: Ad_Segment_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択された動画部分のみがAIに送信されます。これを使用して、スレート、カラーバー、または末尾のコンテンツをスキップできます。開始タイムコードと終了タイムコードは、動画全体を含みます。`)
};

const hi_ad_segment_help = /** @type {(inputs: Ad_Segment_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो का केवल चयनित भाग ही एआई को भेजा जाता है। इसका उपयोग स्लेट, कलर बार या अंत के कंटेंट को छोड़ने के लिए करें - प्रारंभ और समाप्ति टाइमकोड शामिल हैं।`)
};

const pt_pt2_ad_segment_help = /** @type {(inputs: Ad_Segment_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas a parte selecionada do vídeo é enviada para a IA. Use isso para pular a vinheta, as barras de cor ou o conteúdo final — os códigos de tempo de início e fim estão incluídos.`)
};

/**
* | output |
* | --- |
* | "Only the selected portion of the video is sent to the AI. Use this to skip slate, colour bars, or tail content - the start and end timecodes are inclusive." |
*
* @param {Ad_Segment_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_segment_help = /** @type {((inputs?: Ad_Segment_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Segment_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_segment_help(inputs)
	if (locale === "de") return de_ad_segment_help(inputs)
	if (locale === "it") return it_ad_segment_help(inputs)
	if (locale === "ru") return ru_ad_segment_help(inputs)
	if (locale === "es") return es_ad_segment_help(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_segment_help(inputs)
	if (locale === "ja") return ja_ad_segment_help(inputs)
	if (locale === "hi") return hi_ad_segment_help(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_segment_help(inputs)
	return en_ad_segment_help(inputs)
});